import { Installation } from "../Installation";
import { InstalledSoftware } from "../InstalledSoftware";
import { ConfigurationComparisonEnum } from "../enums/ConfigurationComparisonEnum";
import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";
import { ConfigurationSecurity } from "./ConfigurationSecurity";

export class InstallationSecurityConfiguration extends Installation {
    securityConfigurationActual: ConfigurationSecurity = null;
    securityConfigurationReference: ConfigurationSecurity = null;
    scheduled: boolean = false;
    comparisonStatus: ConfigurationComparisonEnum = null;
    agent: Array<InstalledSoftware> = null;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);
        if (obj.SecurityConfigurationActual) {
            this.securityConfigurationActual = new ConfigurationSecurity();
            this.securityConfigurationActual.parse(obj.SecurityConfigurationActual);
        }

        if (obj.SecurityConfigurationReference) {
            this.securityConfigurationReference = new ConfigurationSecurity();
            this.securityConfigurationReference.parse(obj.SecurityConfigurationReference);
        }

        if (obj.Scheduled != null && obj.Scheduled != undefined) this.scheduled = obj.Scheduled;
        if (obj.ComparisonStatus != null && obj.ComparisonStatus != undefined) this.comparisonStatus = obj.ComparisonStatus;

        if (obj.AgentInfo && obj.AgentInfo.Version) {
            this.agent = new Array<InstalledSoftware>();
            let agentSoftware = new InstalledSoftware();
            agentSoftware.name = "Agent";
            agentSoftware.version = obj.AgentInfo.Version;
            agentSoftware.updateType = UpdateTypeEnum.Agent;
            this.agent.push(agentSoftware);
        }
    }
}
